import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IFiltrosDealer } from '../IFiltrosDealer';

@Component({
  selector: 'app-dealer-filtro',
  templateUrl: './dealer-filtro.component.html',
  styleUrls: ['./dealer-filtro.component.scss']
})
export class DealerFiltroComponent implements OnInit {

  @Input() exibeFiltros: boolean = true;
  @Input() filtros: IFiltrosDealer;
  @Output() fecharModalFiltros: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() aplicarFiltros: EventEmitter<IFiltrosDealer> = new EventEmitter<IFiltrosDealer>();
  nome: any;
  cnpj: any;
  codDealer: any;

  constructor() { }

  ngOnInit() {
    this.filtros = {
      nome: '', cnpj: '', codDealer: '', paginaAtual: 1, quantidadeRegistrosPorPagina: 10
    }
  }

  hideDialog() {
    this.exibeFiltros = false;
    this.fecharModalFiltros.emit(this.exibeFiltros);
  }

  enviarFiltros() {
    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }

  limpafiltros() {
    this.filtros = {
      nome: '', cnpj: '', codDealer: '', paginaAtual: 1, quantidadeRegistrosPorPagina: 10
    }
    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }
}
